import UserService from '@/services/user.service'

export default async function authorized ({ next, to, router }) {
  const hasMeta = await UserService.getUserMeta()
  if (!hasMeta && to.name !== 'Unauthorized') {
    router.push({ name: 'Unauthorized' })
  }
  return next()
}
